import React from "react";
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Avatar,
  Menu,
  MenuItem,
  Button,
  Tooltip,
} from "@mui/material";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PickaaGO1Icon from "../../assets/Images/PickaaGoLogo.png";

const TopBar = ({
  fullSideBar,
  setFullSideBar,
  handleLogout,
  topTabs = [], // Only pass this when needed
  userLogo
}) => {
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
console.log(userLogo)
  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#fff",
        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        width: "100%",
        overflowX: "hidden",
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          px: 1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: 64,
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        {/* Left section: Sidebar toggle & Logo */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={() => setFullSideBar((prev) => !prev)}>
            {fullSideBar ? (
              <MenuOpenIcon sx={{ fontSize: 30, color: "#5E6E82" }} />
            ) : (
              <MenuRoundedIcon sx={{ fontSize: 30, color: "#5E6E82" }} />
            )}
          </IconButton>
          <Box
            component="img"
            src={PickaaGO1Icon}
            alt="PickaaGO Logo"
            sx={{ height: 45 }}
          />
        </Box>

        {/* Right section: Tabs + Profile */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {topTabs.map((tab) => (
            <Button
              key={tab.name}
              href={tab.url}
              sx={{
                color: "#737373",
                fontWeight: 500,
                fontSize: "16px",
                textTransform: "none",
                fontFamily: "Source Sans Pro', sans-serif"
              }}
            >
              {tab.name}
            </Button>
          ))}

          <Tooltip title="Account">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar   src={userLogo} 
            alt="User Avatar" 
            />
            </IconButton>
          </Tooltip>

          <Menu
            sx={{ mt: "45px",marginRight:"50px"}}
            anchorEl={anchorElUser}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem
              onClick={() => {
                handleCloseUserMenu();
                handleLogout();
              }}
            >
              <Typography>Logout</Typography>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
